import { bootstrapApplication } from '@angular/platform-browser'
import { appConfig } from './app/app.config'
import { App } from './app/app'

window.addEventListener('error', (event) => {
  const target = event.target as HTMLScriptElement | HTMLLinkElement

  if (target && (target.tagName === 'SCRIPT' || target.tagName === 'LINK')) {
    const src = (target as HTMLScriptElement).src || (target as HTMLLinkElement).href

    if (src && src.includes('chunk-')) {
      const hasReloaded = sessionStorage.getItem('chunk-load-error-reloaded')

      if (!hasReloaded) {
        console.warn('Chunk loading failed, reloading page:', src)
        sessionStorage.setItem('chunk-load-error-reloaded', 'true')
        window.location.reload()
      } else {
        console.error('Chunk loading failed after reload:', src)
        sessionStorage.removeItem('chunk-load-error-reloaded')
      }
    }
  }
}, true)

window.addEventListener('unhandledrejection', (event) => {
  const errorMessage = event.reason?.message || String(event.reason)

  if (errorMessage.includes('Failed to fetch dynamically imported module') ||
      errorMessage.includes('chunk-')) {
    const hasReloaded = sessionStorage.getItem('chunk-load-error-reloaded')

    if (!hasReloaded) {
      console.warn('Dynamic import failed, reloading page:', errorMessage)
      sessionStorage.setItem('chunk-load-error-reloaded', 'true')
      window.location.reload()
    } else {
      console.error('Dynamic import failed after reload:', errorMessage)
      sessionStorage.removeItem('chunk-load-error-reloaded')
    }
  }
})

bootstrapApplication(App, appConfig).catch(err => console.error(err))
